// extracted by mini-css-extract-plugin
export default {"taWrap":"Textarea_taWrap__zOUui","ta":"Textarea_ta__H6hA+"};